import React from 'react';
import { wrapReactionHook } from "../../hooks";
var Sign = wrapReactionHook(function (props) {
  var children = props.children;
  return /*#__PURE__*/React.createElement("div", null, "\u7B7E\u5230\u7B7E\u9000\u7EC4\u4EF6-\u7B7E\u5230(web\u6682\u4E0D\u652F\u6301\u8BE5\u529F\u80FD\uFF0C\u524D\u5F80\u5FAE\u4FE1\u5C0F\u7A0B\u5E8F\u67E5\u770B)");
});
var Skip = wrapReactionHook(function (props) {
  var children = props.children;
  return /*#__PURE__*/React.createElement("div", null, "\u7B7E\u5230\u7B7E\u9000\u7EC4\u4EF6-\u8DF3\u8FC7\u6253\u5361(web\u6682\u4E0D\u652F\u6301\u8BE5\u529F\u80FD\uFF0C\u524D\u5F80\u5FAE\u4FE1\u5C0F\u7A0B\u5E8F\u67E5\u770B)");
});
// @ts-ignore
export var LocationSignInOutSkip = wrapReactionHook(function (props) {
  var children = props.children;
  return /*#__PURE__*/React.createElement("div", null, "\u7B7E\u5230\u7B7E\u9000\u7EC4\u4EF6(web\u6682\u4E0D\u652F\u6301\u8BE5\u529F\u80FD\uFF0C\u524D\u5F80\u5FAE\u4FE1\u5C0F\u7A0B\u5E8F\u67E5\u770B)");
});
LocationSignInOutSkip.Sign = Sign;
LocationSignInOutSkip.Skip = Skip;